import { Avatar } from '@components/avatar/avatar';
import { Stack } from '@components/stack';
import { Text } from '@components/text';

export interface AvatarInfoProps {
  title: string;
  src?: string | null;
  subtitles?: string[];
}

export const AvatarInfo = ({ src, title, subtitles }: AvatarInfoProps) => {
  return (
    <Stack orientation="horizontal" space={6} align="center">
      <Avatar name={title} src={src} size="xl" />
      <Stack space={1}>
        <Text font="bold18" dataTestid="avatar-title">
          {title}
        </Text>
        <Stack>
          {subtitles?.map((subtitle, index) => (
            <Text font="regular14" key={index} dataTestid={`avatar-subtitle-${index}`}>
              {subtitle}
            </Text>
          ))}
        </Stack>
      </Stack>
    </Stack>
  );
};
